import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { processLogin } from 'myredux/loginActions';
import { LoginResponseDTO, LoginState } from 'types';


const initialState: LoginState = {
    loading: false,
    token: undefined,
    user: undefined,
    expirationDate: undefined
};

const loginSlice = createSlice({
  name: 'login',
  initialState,
  reducers: {
    setData: (state: LoginState, { payload }: PayloadAction<LoginResponseDTO>) => {
        state.user = payload.user;
        state.token = payload.token;
        state.expirationDate = new Date(new Date().getTime() + payload.expiresIn);
    },
    logout: (state: LoginState) => {
      state.loading = false;
      state.user = undefined;
      state.token = undefined;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(processLogin().pending, (state: LoginState) => {
        state.loading = true;
      })
      .addCase(processLogin().fulfilled, (state: LoginState) => {
        state.loading = false;
      })
      .addCase(processLogin().rejected, (state: LoginState, action) => {
        state.loading = false;
        state.user = undefined;
        state.token = undefined;
        state.expirationDate = undefined;
      });
  },
});

export const { setData, logout } = loginSlice.actions;
export default loginSlice.reducer;
